export const LOCAL_DEMO_PROJECT_ID = 'demo-qkindex-local';
export const LOCAL_EMULATOR_HOST = '127.0.0.1';

export const LOCAL_EMULATOR_PORTS = Object.freeze({
  auth: 9099,
  firestore: 18080,
  functions: 5001,
  storage: 9199,
});

export interface LocalFirebaseEnvironment {
  projectId?: string;
  useEmulators?: string;
  host?: string;
  authPort?: string;
  firestorePort?: string;
  functionsPort?: string;
  storagePort?: string;
}

export const assertLocalFirebaseEnvironment = (
  environment: LocalFirebaseEnvironment,
): void => {
  if (environment.projectId !== LOCAL_DEMO_PROJECT_ID) {
    throw new Error(
      `Local development requires Firebase project ${LOCAL_DEMO_PROJECT_ID}.`,
    );
  }
  if (environment.useEmulators !== 'true') {
    throw new Error(
      'Local development requires Firebase emulators to be enabled.',
    );
  }
  const expected = [
    ['host', environment.host, LOCAL_EMULATOR_HOST],
    ['authPort', environment.authPort, String(LOCAL_EMULATOR_PORTS.auth)],
    [
      'firestorePort',
      environment.firestorePort,
      String(LOCAL_EMULATOR_PORTS.firestore),
    ],
    [
      'functionsPort',
      environment.functionsPort,
      String(LOCAL_EMULATOR_PORTS.functions),
    ],
    [
      'storagePort',
      environment.storagePort,
      String(LOCAL_EMULATOR_PORTS.storage),
    ],
  ] as const;
  const mismatch = expected.find(([, actual, required]) => actual !== required);
  if (mismatch)
    throw new Error(
      `Local development requires ${mismatch[0]}=${mismatch[2]}.`,
    );
};
